import React, {useState, useCallback, useEffect} from 'react';
import { useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useMutation, useLazyQuery } from '@apollo/client';
import DataState from 'app/src/components/DataState';
import Input from 'app/src/elements/inputs';
import { Button, ButtonGroup } from 'app/src/elements/buttons';
import { View, Pressable } from 'react-native';

import { CREATE_SELLER_USER } from './queries';
import { ButtonContainer } from './elements';
import { NOTIFICATION_OPTIONS } from './index';

import { CONTACTS_WITH_COUNT } from '../../Contacts/queries';
import { Text } from 'app/src/styles';

const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const NewSellerUser = ({
    knownSellerId,
    setShowModal,
    setUpdatedSellerUserDetails,
    refetch
  }) => {
  const [submitting, setSubmitting] = useState();
  const [createdData, setCreatedData] = useState();
  const sellerId = useParams().sellerId || knownSellerId;
  const [contacts, setContacts] = useState();
  const [createSellerUser] = useMutation(CREATE_SELLER_USER, {
    onCompleted: (response) => {
      if(refetch) {
        refetch();
      }
      if(setUpdatedSellerUserDetails) {
        setUpdatedSellerUserDetails(response?.createSellerUser?.sellerUser, true);
      }
      if (response?.createSellerUser?.acceptUrl) {
        setCreatedData(response.createSellerUser);
      } else {
        setShowModal(false);
      }
    }
  });
  const [ loadContacts, { loading: loading, data: data } ] =
    useLazyQuery(CONTACTS_WITH_COUNT, {
      onCompleted: () => setContacts(data?.contactsWithCount?.entries)
    }
  );

  const onSubmit = useCallback(input => {
    setSubmitting(true);
    createSellerUser({ variables: input });
  });

  const { control, handleSubmit, register, watch, formState: { errors } } = useForm({
    defaultValues: {
      sellerId: sellerId,
      firstName: '',
      lastName: '',
      email: '',
      role: 'Admin',
      contactId: '',
      assetNotifications: 'include_unassigned',
    }
  });

  useEffect(() => {
    loadContacts({variables: {sellerId: sellerId}})
  }, [])

  const copyInvite = level => {
    let value = createdData.acceptUrl;

    if ('all' === level) {
      value = `${createdData.sellerUser.fullName}, ` +
        `${createdData.sellerUser.email}. Click to set password: ` +
        value;
    }

    navigator.clipboard.writeText(value);
  }

  if (createdData) {
    return (
      <View>
        <Text>UAT Seller user has been setup.</Text>
        <Text style={{marginBottom: 10}}>
          If the user has an
          equiplincuactions.com email address, they will receive invitation
          instructions. Otherwise, you will need to send them.
        </Text>
        <Text>{createdData.sellerUser.fullName}</Text>
        <Text>{createdData.sellerUser.email}</Text>
        <Text>Accept URL: {createdData.acceptUrl}</Text>
        <Pressable onPress={() => copyInvite('all')} style={{marginTop: 20}}>
          <Text>Click to copy name, email and URL</Text>
        </Pressable>
        <Pressable onPress={() => copyInvite('url')}>
          <Text>Click to copy URL only</Text>
        </Pressable>
      </View>
    );
  }

  return (
    <View>
      {/* <SubNav /> */}
      {submitting ?
        DataState.Loading :
        <View>
          <Input.Text
            label="Email:"
            name="email"
            control={control}
            errors={errors}
            id="email"
            {...register("email", {
              required: "Required",
              validate: {
                maxLength: (v) =>
                  v.length <= 50 || "Email should have at most 50 characters",
                matchPattern: (v) => EMAIL.test(v) ||
                  "Must be a valid email address",
              },
            })}
          />
          <Input.Text
            label="First Name:"
            name="firstName"
            control={control}
            errors={errors}
            {...register("firstName", {
              required: "Required"
            })}
          />
          <Input.Text
            label="Last Name:"
            name="lastName"
            control={control}
            errors={errors}
            {...register("lastName", {
              required: "Required"
            })}
          />
          <Input.Picker
            label="Contact:"
            name="contactId"
            options={
              contacts?.map(contact => {
                return {
                  value: contact.id,
                  label: `${contact.firstName} - ${contact.email}`
                }
              })
            }
            control={control}
            errors={errors}
          />
          <Input.Picker
            label="Role:"
            name="role"
            options={[
              { value: 'Admin', label: 'Admin' },
              { value: 'Normal', label: 'Normal' },
            ]}
            control={control}
            errors={errors}
          />
          <Input.Picker
            label="Receive asset notifications:"
            name="assetNotifications"
            options={NOTIFICATION_OPTIONS}
            control={control}
            errors={errors}
          />
          <ButtonContainer>
            <ButtonGroup>
              <Button label="Create Seller User" onPress={handleSubmit(onSubmit)} />
            </ButtonGroup>
          </ButtonContainer>
        </View>
      }
    </View>
  )
}

export default NewSellerUser;
